import { BDCPProductDetailsRootComponent } from './pages/root/root.page';
import { BDCPProductImageViewerComponent } from './components/product-image-viewer/product-image-viewer.component';
import { BDCPProductPricesComponent } from './components/product-prices/product-prices.component';
import { BDCPSharedModule } from '../shared/shared.module';
import { BDSharedModule } from '@brother-apps/brother-dealerapp-shared-lib';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BDCPSharedModule,
        BDSharedModule
    ],
    declarations: [
        // Pages
        BDCPProductDetailsRootComponent,
        // Components
        BDCPProductImageViewerComponent,
        BDCPProductPricesComponent
    ],
    exports: [
        // Pages
        BDCPProductDetailsRootComponent,
        // Components
        BDCPProductImageViewerComponent,
        BDCPProductPricesComponent
    ],
    providers: [

    ]
})
export class BDCPProductDetailsModule { }
